import { GrupoUnidadMedidaInputProps } from '../interfaces'

export const grupoUnidadMedidaRegistroComposeService = (
  input: GrupoUnidadMedidaInputProps,
): any => {
  return {
    nombreGrupo: input.nombreGrupo,
    codigoUnidadMedidaBase: input.codigoUnidadMedidaBase,
    definicion: input.definicion,
  }
}
